/* eslint-disable no-alert */
import {
    UPDATE_MESSAGE_START,
    UPDATE_MESSAGE_SUCCESS,
    UPDATE_MESSAGE_FAIL,
} from './constants'

export default (state = {}, action) => {
    let newState

    switch (action.type) {
        case UPDATE_MESSAGE_START:
            newState = {
                ...state,
                loading: true,
                sent: false,
                sentMessageId: '',
            }
            break
        case UPDATE_MESSAGE_SUCCESS:
            {
                const { payload } = action

                newState = {
                    ...state,
                    loading: false,
                    sent: true,
                    sentMessageId: payload,
                }
            }
            break
        case UPDATE_MESSAGE_FAIL:
            {
                const err = 'Cannot update message!'
                alert(err)

                newState = {
                    ...state,
                    loading: false,
                    sent: false,
                    sentMessageId: '',
                }
            }
            break
        default:
            newState = state
            break
    }

    return newState
}
